import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_employees_edit_form = _resolveComponent("employees-edit-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_employees_assign_password_form = _resolveComponent("employees-assign-password-form")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_tabs, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
      "indicator-color": "primary",
      align: "left",
      "narrow-indicator": "",
      class: "bg-grey-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tab, {
          name: "edit",
          label: "Edit employee data"
        }),
        _createVNode(_component_q_tab, {
          name: "password",
          label: "Set new password"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_separator),
    _createVNode(_component_q_tab_panels, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tab_panel, {
          name: "edit",
          class: "q-pt-md q-px-none"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, {
              flat: "",
              bordered: "",
              square: "",
              class: "q-pa-lg"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_employees_edit_form, { employee: _ctx.employeeFormModel }, null, 8, ["employee"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_tab_panel, {
          name: "password",
          class: "q-pt-md q-px-none"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, {
              flat: "",
              bordered: "",
              square: "",
              class: "q-pa-lg"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_employees_assign_password_form, { employee: _ctx.employeeModel }, null, 8, ["employee"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}